// The doctor's first discharge step for a Day Care session: the "Discharge
// Advice" care plan. The IPD doctor console files it inline
// (PatientDetailsPanel.js handleAddCarePlan, not exported), so this posts to
// the same two endpoints. Every later step reuses the exported
// src/pages/ipd/api/dischargeProcessApi.js functions directly.

import axios from "axios";
import { BASE } from "./daycareApi";
import { getCarePlanTasks, listOf } from "../../nurse-dashboard/api/nurseApi";

/** The care-plan template that is Discharge Advice (the nurse's initiate
 *  button unlocks on a task with this template id). */
const DISCHARGE_ADVICE_TEMPLATE_ID = 7;

/** True when the doctor's Discharge Advice task exists — the same gate the
 *  nurse dashboard puts on its Initiate discharge button. */
export function hasDischargeAdvice(tasks) {
  return (tasks || []).some((t) => Number(t?.template_id) === DISCHARGE_ADVICE_TEMPLATE_ID);
}

/** Whether advice was ever filed for the admission (the nurse dashboard's
 *  unfiltered care_plan_tasks/ read). */
export async function fetchHasDischargeAdvice(admissionId) {
  return hasDischargeAdvice(listOf(await getCarePlanTasks({ admission_id: admissionId })));
}

const headers = () => ({ Authorization: `Bearer ${sessionStorage.getItem("accessToken") || ""}` });

/**
 * File the Discharge Advice care plan. The structure is found by template id,
 * not by name, so a renamed structure still resolves.
 * @returns {{ ok: boolean, message: string }}
 */
export async function fileDischargeAdvice(admissionId, { date, time, notes }) {
  const list = await axios.get(`${BASE}care_plan_structures/`, { headers: headers() });
  const rows = Array.isArray(list?.data?.data) ? list.data.data : [];
  const advice = rows.find((row) => Number(row.template_id) === DISCHARGE_ADVICE_TEMPLATE_ID);
  if (!advice) return { ok: false, message: "Discharge Advice is not set up for this hospital" };

  const res = await axios.post(
    `${BASE}care_plans/`,
    {
      admission_id: admissionId,
      care_plans: [{
        care_plan_id: advice.id,
        data: { expected_discharge_date: date, expected_discharge_time: time, notes: notes || "" },
      }],
    },
    { headers: headers() },
  );
  return { ok: res?.data?.status === "Success", message: res?.data?.message || "" };
}
